const hoverintent = require('hoverintent');
import { Dropdown } from 'bootstrap';

const header = document.querySelector('header.header')
const navToggles = header.querySelectorAll('.topbar-nav-item, .main-nav-item');

let activeDropdown;

navToggles.forEach(elem => {
  let toggle = elem.querySelector('.dropdown-toggle');

  if (toggle) {
    let thisDropdown = Dropdown.getOrCreateInstance(toggle);

    // Don't hide dropdown when clicking an already open dropdown toggle.
    //
    // When a user clicks on the dropdown toggle, hover intent may
    // have shown the dropdown just before it was clicked. The event listener
    // below prevents it from being hidden by a click right after it was shown
    // by hover intent.
    toggle.addEventListener('click', function () {
      thisDropdown.show();
    });

    hoverintent(elem,
      function () {
        if (activeDropdown) {
          activeDropdown.hide();
        }
        activeDropdown = thisDropdown;
        thisDropdown.show();
      }, function () {
        thisDropdown.hide();
      }
    ).options({
      sensitivity: 7,
      interval: 50,
      timeout: 300
    });
  }
});

function modalPop() {
  modal.classList.toggle("active-modal");
}

var modal = document.querySelector('.interest-rate-modal');
var modalInner = document.querySelector('.interest-rate-modal-popup');
var interestButton = document.querySelector('.interest-rate-button');
var closeButton = document.querySelector('.modal-close');

interestButton.addEventListener('click', function () {
  modalPop()
});
closeButton.addEventListener('click', function () {
  modalPop()
});
modal.addEventListener('click', function(e){
  if (!modalInner.contains(e.target)){
    modalPop()
  }
});

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function announcementModalPop() {
  announcementModal.classList.toggle("active-announcement-modal");
}

let announcementModal = document.querySelector('.announcement-modal');
let announcementModalInner = document.querySelector('.announcement-modal-popup');
let announcementCloseButton = document.querySelector('.announcement-modal-top');
let announcementCloseButton2 = document.querySelector('.announcement-btn');

announcementCloseButton.addEventListener('click', function () {
  let mediaQuery = window.innerWidth;
  var cookie = getCookie('announcement');
  if(!cookie) {
    console.log('no cookie');
    setCookie('announcement','closed',7);
  }
  announcementModalPop();
  if(mediaQuery >= 900) {
    $('.announcement-modal-bottom').slideToggle(400, 'swing');
  } else {
    $('.announcement-modal-bottom').slideToggle(300, 'swing');
  }
});

announcementCloseButton2.addEventListener('click', function () {
  var cookie = getCookie('announcement');
  if(!cookie) {
    console.log('no cookie');
    setCookie('announcement','closed',7);
  }
  announcementModalPop();
  $('.announcement-modal-bottom').slideToggle('1200', 'swing');
});

window.onload = function() {

  var cookie = getCookie('announcement');
  if(!cookie) {
    setTimeout(function() {
      announcementModalPop();
      $('.announcement-modal-popup').removeClass('onload-popup');
      $('.announcement-modal-bottom').css('display', 'block');
      setTimeout(function() {
        $('.announcement-modal-popup').removeClass('initial-popup');
        }, 2000);
    }, 1000);
  } else {
    $('.announcement-modal-popup').css('bottom','-90px');
    $('.announcement-modal-popup').removeClass('initial-popup');
    setTimeout(function() {
      $('.announcement-modal-popup').removeClass('onload-popup');
      setTimeout(function() {
        $('.announcement-modal-popup').css('bottom','0px');
      }, 800);
    }, 1000);
  }
};
